import React, { Fragment, useEffect } from "react";
import Consequences from "./Consequences";
import Card from "./Card";
import { useTranslation } from "react-i18next";

const Game = ({
  decisions,
  handleSelectDecision,
  selectedDecisions,
  canValidate,
  validateDecisions,
  consequences,
  showConsequences,
  hideConsequences,
  round,
  initialShortTermNeeds,
  showAdditionalScore,
  language,
}) => {
  const isSelected = (id) => selectedDecisions.find((d) => d._id === id);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (language) i18n.changeLanguage(language);
  }, [language, i18n]);

  return (
    <div className={`gm-page ${initialShortTermNeeds > 0 && !showConsequences ? "gm-page--danger" : ""}`}>
      {showConsequences ? (
        <Consequences consequences={consequences} hideConsequences={hideConsequences} />
      ) : (
        <Fragment>
          {initialShortTermNeeds > 0 && (
            <div className="gm-crisis-banner">
              <span className="gm-crisis-icon">⚠️</span>
              <span>{t("Situation de crise - choisissez des mesures d'urgence")}</span>
            </div>
          )}

          <div className="gm-cards-grid">
            {decisions.map((decision) => (
              <Card
                key={decision._id}
                decision={decision}
                selected={!!isSelected(decision._id)}
                handleSelect={handleSelectDecision}
                round={round}
                initialShortTermNeeds={initialShortTermNeeds}
                showAdditionalScore={showAdditionalScore}
                t={t}
              />
            ))}
          </div>

          {canValidate && (
            <div className="gm-validate-bar">
              <button className="gm-validate-btn" onClick={validateDecisions}>
                {t("Valider la décision")}
              </button>
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default Game;
